<p-progressBar *ngIf="showProgressBar" class="progress-container" [value]="uploadProgress" [showValue]="showProgressPercentage"></p-progressBar>
